import React, { useState, useEffect } from "react";
import DetailedProjectModal from "./DetailedProjectModal";
import MoreProjectsModal from "./MoreProjectsModal"; // Import the modal
import "./TopicModal.css";
import Macau2 from "../assets/projects/Estabilidade1.avif";
import Macau3 from "../assets/projects/ContencaoPeriferica1.jpg";
import Macau4 from "../assets/projects/Hidraulicas1.avif";
import Macau5 from "../assets/projects/extintores.jpg";
import Arcadia1 from "../assets/projects/aquecimento.avif";
import Arcadia2 from "../assets/projects/gas.avif";
import Arcadia3 from "../assets/projects/temperatura.avif";
import Arcadia4 from "../assets/projects/REH.jpeg";
import Arcadia5 from "../assets/projects/acustic.avif";

function TopicModal({ topic, onClose, onMoreProjects }) {


  useEffect(() => {
    // Disable scrolling on the main page
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      // Re-enable scrolling when the modal closes
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  const [selectedProject, setSelectedProject] = useState(null);
  const [showMoreProjects, setShowMoreProjects] = useState(false);

  // Condição para verificar se é o tópico "Outras Especialidades"
  const isOtherSpecialties = topic.title === "Outras Especialidades";

  const specialties = [
    { name: "Projeto de Estabilidade", image: Macau2 },
    { name: "Projeto de Contenção Periférica", image: Macau3 },
    { name: "Projeto de Instalações Hidráulicas", image: Macau4 },
    { name: "Projeto de Segurança Contra Incêndios em Edifícios (SCIE)", image: Macau5 },
    { name: "Projeto de Instalações Mecânicas de Aquecimento, Ventilação e Ar Condicionado", image: Arcadia1 },
    { name: "Projeto de Instalação Interna de Gás", image: Arcadia2 },
    { name: "Projeto de Comportamento Térmico", image: Arcadia3 },
    { name: "Certificação Energética REH", image: Arcadia4 },
    { name: "Projeto de Acústico", image: Arcadia5 },
    
  ];

  const topicsWithMoreProjectsButton = [
    "Telecomunicações e Segurança",
    "Instalações elétricas de média e baixa tensão"
  ];

  const showMoreProjectsButton = topicsWithMoreProjectsButton.includes(topic.title);
  const hasProjects = topic.projects.length > 0;


  // Calcula o número de colunas com base no número de projetos
  const numProjects = topic.projects.length;
  let numColumns = numProjects % 3 === 0 ? 3 : 2; // 3 colunas se divisível por 3, senão 2
  let minWidth = "280px"; // Largura mínima padrão

  if (numProjects === 1) {
    numColumns = 1; // Apenas uma coluna para um projeto
    minWidth = "80%"; // Largura mínima maior para 1 projeto
  } else if (numProjects === 2) {
    minWidth = "40%"; // Largura mínima maior para 2 projetos
  } else if (numProjects === 4) {
    minWidth = "30%"; // Largura mínima média para 4 projetos
  } else if (numProjects === 6) {
    minWidth = "20%"; // Largura mínima menor para 6 projetos
  }

  return (
    <>
      <div className="topicModal">
        <h2>{topic.title}</h2>
        <button className="closeButton" onClick={onClose}>&times;</button>

        {isOtherSpecialties ? (
          <div className="gridContainer">
            {specialties.map((specialty) => (
              <div key={specialty.name} className="specialtyCard" style={{ backgroundImage: `url(${specialty.image})` }}>
                <div className="specialtyCardTitle">{specialty.name}</div>
              </div>
            ))}
          </div>
        ) : hasProjects ? (
          <div
            className="projectsContainer"
            style={{ gridTemplateColumns: `repeat(${numColumns}, minmax(${minWidth}, 1fr))` }}
          >
            {topic.projects.map((project) => (
              <div
                key={project.client}
                className="projectPreview"
                onClick={() => setSelectedProject(project)}
              >
                <img src={project.image} alt={project.client} className="projectImage" />
                <div className="projectNameOverlay">{project.client}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="topicProgressState">
            <div
              className="topicProgressVisual"
              style={{ backgroundImage: `linear-gradient(rgba(24, 46, 64, 0.38), rgba(24, 46, 64, 0.62)), url(${topic.image})` }}
            >
              <span className="topicProgressBadge">
                {topic.progressMessage || "Em progresso."}
              </span>
            </div>

            <div className="topicProgressContent">
              <h3>{topic.progressTitle || "Portfólio em atualização"}</h3>
              <p>
                {topic.progressDescription ||
                  "Estamos a preparar esta área para apresentar os projetos com mais detalhe em breve."}
              </p>
            </div>
          </div>
        )}

        {showMoreProjectsButton && (
          <button
            className="moreProjectsButton"
            onClick={() => setShowMoreProjects(true)}
          >
            Mais projetos
          </button>
        )}
      </div>

      {showMoreProjects && (
        <MoreProjectsModal
          projects={topic.moreProjects}
          onClose={() => setShowMoreProjects(false)}
        />
      )}

      {selectedProject && (
        <DetailedProjectModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </>
  );
}

export default TopicModal;
